import ApiIntegrface from './api'

export function createCatKey(payload, callback, errhandler) {
  const api = new ApiIntegrface()
  api.post('/api/v1/catkeys', payload, callback, errhandler, null, null, false)
}

export function getCatKeys(cat, callback, errhandler) {
  const api = new ApiIntegrface()
  const params = cat != null && cat !== '' ? { cat } : null
  api.get('/api/v1/catkeys', params, callback, errhandler, null, null, false)
}

/** POST each {cat,key,value} sequentially; continues on individual failures. */
export function createCatKeys(items, callback) {
  const list = Array.isArray(items) ? items.filter(Boolean) : []
  if (!list.length) {
    if (callback) callback([])
    return
  }
  const results = []
  let index = 0
  const next = () => {
    if (index >= list.length) {
      if (callback) callback(results)
      return
    }
    const payload = list[index++]
    createCatKey(
      payload,
      (res) => {
        results.push({ ok: true, payload, res })
        next()
      },
      (err) => {
        results.push({ ok: false, payload, err })
        next()
      }
    )
  }
  next()
}
